import React, { useEffect } from 'react';

// Curated diverse selection of event photos
import Gal1 from '../assets/images/IMG_0553.jpg';
import Gal2 from '../assets/images/IMG_0650.JPG';
import Gal3 from '../assets/images/IMG_1421.JPG';
import Gal4 from '../assets/images/IMG_0780.JPG';
import Gal5 from '../assets/images/IMG_0569.jpg';
import Gal6 from '../assets/images/IMG_0810.JPG';
import Gal7 from '../assets/images/IMG_0575.jpg';
import Gal8 from '../assets/images/IMG_0590.jpg';
import Gal9 from '../assets/images/IMG_0660.JPG';
import Gal10 from '../assets/images/IMG_0769.JPG';
import Gal11 from '../assets/images/IMG_1054.JPG';
import Gal12 from '../assets/images/IMG_0582.jpg';

const Gallery = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const photos = [Gal1, Gal2, Gal3, Gal4, Gal5, Gal6, Gal7, Gal8, Gal9, Gal10, Gal11, Gal12];

  return (
    <>
      <section className="page-hero">
        <div className="container page-hero__content">
          <h1 className="page-hero__title">Event Gallery</h1>
          <div className="breadcrumb">
            <a href="/">Home</a> <span>/</span> Gallery
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="text-center">
            <div className="eyebrow" style={{justifyContent: 'center'}}>Relive The Moments</div>
            <h2 className="section-title">Past Editions</h2>
          </div>

          <div className="gallery-full-grid">
            {photos.map((src, i) => (
              <div key={i} className="gallery-full-item">
                <img src={src} alt={`Gallery ${i}`} loading="lazy" />
                <div className="gallery-full-item__overlay">
                  <svg width="32" height="32" fill="white" viewBox="0 0 24 24">
                    <path d="M12 9a3 3 0 100 6 3 3 0 000-6zm0-2a5 5 0 110 10 5 5 0 010-10zm9 11v1a1 1 0 01-1 1H4a1 1 0 01-1-1v-1a1 1 0 011-1h16a1 1 0 011 1zm-1-8H4v6h16V10zM5.5 3h13C19.88 3 21 4.12 21 5.5v3a1 1 0 01-2 0V5.5a.5.5 0 00-.5-.5h-13a.5.5 0 00-.5.5v3a1 1 0 01-2 0v-3C3 4.12 4.12 3 5.5 3z"/>
                  </svg>
                </div>
              </div>
            ))}
          </div>
          
          <div className="text-center mt-12">
            <button className="btn btn-outline-red">Load More Photos</button>
          </div>
        </div>
      </section>
    </>
  );
};

export default Gallery;
